import React, {useCallback, useMemo, useState, useEffect } from "react";
import {useHistory, useLocation, useParams} from 'react-router-dom';
import Prev from "../../assets/image/icon_prev.svg"
import ViewIcon from "../../assets/image/icon_eye.svg";
import Split from "../../assets/image/split.svg";
import Download from "../../assets/image/icon-download-white.svg"
import useFetch from "@common/hooks/fetch/useFetch";
import {getLitDetail} from "@common/services/restapi/lit";
import {Moments} from "@common/utils/date/moments";
import moveExternalLink from "@common/utils/app/appBridge"

function LitDetailView() {
  const history = useHistory();
  const {category, ukey} = useParams();

  const {data: litDetailView} = useFetch(() => getLitDetail(category, { ukey : ukey}), [], {});

  const handleGoBack = useCallback(() => {
    history.goBack();
  },[]);

  return (
    <>
      <div className="common-header--top">
        <a className="prev-btn" onClick={handleGoBack}>
          <img src={Prev} alt=""/>
        </a>
        <h3 className="header-title">전문자료</h3>
      </div>
      {
        litDetailView &&
        <div className="common-body--content">
          <div className="header-box">
            <div className="publisher">{litDetailView.publisher}</div>
            <h4 className="title">{litDetailView.title}</h4>
            <div className="row-box">
              <div className="view-count">
                <img src={ViewIcon} alt=""/>
                <span>{litDetailView.rcount}</span>
              </div>
              <img src={Split} alt=""/>
              <div className="created-date">{Moments.Format(litDetailView.wdate, 'yyyy.MM.DD')}</div>
              <a target="_blank" href={`https://www.adic.or.kr/lit/paper/download.xhr?objectType=LP&objectUkey=${litDetailView.ukey}&fileName=${litDetailView.ukey}.pdf`}
                 onClick={() => moveExternalLink(event, `https://www.adic.or.kr/lit/paper/download.xhr?objectType=LP&objectUkey=${litDetailView.ukey}&fileName=${litDetailView.ukey}.pdf`, '_blank')}
                 className="download-img">
                <img src={Download} alt=""/>
              </a>
            </div>
          </div>
          <div className="body-box">
            {
              litDetailView.summary && litDetailView.summary !== '' &&
              <div className="content-box">
                <div className="heading">자료요약</div>
                <p className="summary" dangerouslySetInnerHTML={{ __html: litDetailView.summary }}>
                </p>
              </div>
            }
            {
              litDetailView.toc && litDetailView.toc !== '' &&
              <div className="content-box">
                <div className="heading">목차</div>
                <p className="summary" dangerouslySetInnerHTML={{ __html: litDetailView.toc }}>
                </p>
              </div>
            }
            {
              litDetailView.tag && litDetailView.tag !== '' &&
              <div className="content-box">
                <div className="heading">태그</div>
                <p className="summary" dangerouslySetInnerHTML={{ __html: litDetailView.tag }}>
                </p>
              </div>
            }
          </div>
        </div>
      }
    </>

  )
}

export default LitDetailView;
